/**
 * A stable per-browser anonymous actor id.
 *
 * `ListItem.addedBy` / `ActorMark.by` (core `lists.ts`) are free-text actor
 * identifiers used only to break same-millisecond ties in `mergeItem` and to label
 * "who added it" — there is no account for a share-link visitor (see backend.ts's
 * header), so this stands in for `userId` the way an authenticated request's Clerk
 * `sub` would.
 */
const KEY = 'carn.web.guestId';

export function getGuestId(): string {
  if (typeof window === 'undefined') return 'guest';
  let id = window.localStorage.getItem(KEY);
  if (!id) {
    id = `guest-${Math.random().toString(36).slice(2, 8)}`;
    window.localStorage.setItem(KEY, id);
  }
  return id;
}
